import { render, staticRenderFns } from "./MotorAdmin.vue?vue&type=template&id=edadc432&"
import script from "./MotorAdmin.vue?vue&type=script&lang=js&"
export * from "./MotorAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports